<app-header [selectedMenu]="selectedMenu"></app-header>

<div class="container" (scroll)="onScrollTop($event)">

  <!-- div class="wrapper" #main
       (click)="onFocusMain($event)" -->
  <div class="wrapper">
    <aside class="rope"
           (click)="onClickRope($event)">
      <div class="up-arrow"></div>
    </aside>
    <app-back-btn></app-back-btn>

    <section class="search-result">

      <div #extContainer
           class="inner wrap flex-column">

        <app-search-box #extHeader
                        [keyword]="keyword"
                        [placeholder]="placeholder"
                        [keyHistoryKeyword]="HISTORY_KEY_SEARCH_TOTAL"
                        [top]="scrollTop"
                        (search)="onSearch($event)"></app-search-box>

        <div class="search-body-box">


          <article class="book-layout">

            <div #extBody2
                 class="book-layout-wrap">

              <div class="book-page-list">

                <div #extBody
                     class="book-page-group">

                  <div class="page-box" >
                    <div #container
                         class="page-contents scroll-effect over-y">

                      <article #page
                               class="result-list-layout1"
                               [class.empty]="!IsLoading && !(loadComplete$ | async)"
                               style="padding-bottom: 20px;">
                        <div #innerScroll
                             class="list-wrap">

                          <!-- 단어 목록 -->
                          <ng-container *ngIf="!IsLoading && countWord > 0">
                            <div class="subject-box total-subject-word">
                              <div class="subject-txt">단어 검색 결과</div>
                            </div>

                            <ul>
                              <li *ngFor="let word of listWord; let idx = index"
                                  [id]="'total-word-' + word.id">
                                <app-word-list-item [word]="word"
                                                    (viewInit)="onWordViewInit($event)"
                                                    (click)="onSelectWord($event, word)">
                                </app-word-list-item>
                              </li>

                              <li *ngIf="!IsLoading && listWord && countWord > listWord.length">
                                <a class="more-result"
                                   [routerLink]="['/word', LIST_TYPE.SERVER]" [queryParams]="{ keyword: keyword }">{{ countWord }}개 더 보러 가기</a>
                              </li>
                            </ul>
                          </ng-container>

                          <!-- 문장 듣기 목록 -->
                          <ng-container *ngIf="!IsLoading && countExample > 0">
                            <div class="subject-box total-subject-example" style="margin-top: 5.0rem">
                              <div class="subject-txt">문장 듣기 검색 결과</div>
                            </div>
                            <ul>
                              <li *ngFor="let example of listExample; let idx = index"
                                  [id]="'total-example-' + example.id">
                                <app-example-list-item [example]="example"
                                                       [manualPlay]="true"
                                                       (click)="onSelectExample($event, example)"
                                                       (play)="onSelectExample($event, example, true)">
                                </app-example-list-item>
                              </li>

                              <li *ngIf="!IsLoading && listExample && countExample > listExample.length">
                                <a class="more-result"
                                   [routerLink]="['/example', LIST_TYPE.SERVER]" [queryParams]="{ keyword: keyword }">{{ countExample }}개 더 보러 가기</a>
                              </li>
                            </ul>
                          </ng-container>

                          <!-- 사 성 옥편 목록 -->
                          <ng-container *ngIf="!IsLoading && countSaseung > 0">
                            <div class="subject-box total-subject-saseung" style="margin-top: 5.0rem">
                              <div class="subject-txt">사 성 옥편 검색 결과</div>
                            </div>
                            <ul>
                              <li *ngFor="let saseung of listSaseung; let idx = index"
                                  [id]="'total-saseung-' + saseung.id">
                                <app-saseung3-item class="item-box"
                                                   [saseung3]="saseung"
                                                   [showHangul]="true"
                                                   [showBookmarkButton]="false"
                                                   (click)="onSelectSaseung($event, saseung)"
                                                   (viewInit)="onSaseungViewInit($event)">
                                </app-saseung3-item>
                              </li>

                              <li *ngIf="!IsLoading && listSaseung && countSaseung > listSaseung.length">
                                <a class="more-result"
                                   [routerLink]="['/saseung']" [queryParams]="{ keyword: keyword }">{{ countSaseung }}개 더 보러 가기</a>
                              </li>
                            </ul>
                          </ng-container>

                          <!-- 지방어 목록 -->
                          <ng-container *ngIf="!IsLoading && countDialect > 0">
                            <div class="subject-box total-subject-dialect" style="margin-top: 5.0rem">
                              <div class="subject-txt">우리말 검색 결과</div>
                            </div>

                            <ul>
                              <li *ngFor="let dialect of listDialect; let idx = index"
                                  [id]="'total-dialect-' + dialect.id">
                                <app-dialect-item class="item-box"
                                                  [dialect]="dialect"
                                                  (viewInit)="onDialectViewInit($event)"
                                                  (click)="onSelectDialect($event, dialect)">
                                </app-dialect-item>
                              </li>

                              <li *ngIf="!IsLoading && listDialect && countDialect > listDialect.length">
                                <a class="more-result"
                                   [routerLink]="['/dialect', 'list', LIST_TYPE.SERVER]" [queryParams]="{ keyword: keyword }">{{ countDialect }}개 더 보러 가기</a>
                              </li>
                            </ul>
                          </ng-container>

                          <!-- 속담 목록 -->
                          <ng-container *ngIf="!IsLoading && countProverb > 0">
                            <div class="subject-box total-subject-proverb" style="margin-top: 5.0rem">
                              <div class="subject-txt">속담 검색 결과</div>
                            </div>
                            <ul>
                              <li *ngFor="let proverb of listProverb; let idx = index"
                                  [id]="'total-proverb-' + proverb.id">
                                <app-proverb-detail class="item-box"
                                                    [proverb]="proverb"
                                                    [selected]="false"
                                                    (click)="onSelectProverb($event, proverb)"
                                                    (viewInit)="onProverbViewInit($event)">
                                </app-proverb-detail>
                              </li>

                              <li *ngIf="!IsLoading && listProverb && countProverb > listProverb.length">
                                <a class="more-result"
                                   [routerLink]="['/proverb', LIST_TYPE.SERVER]" [queryParams]="{ keyword: keyword }">{{ countProverb }}개 더 보러 가기</a>
                              </li>
                            </ul>
                          </ng-container>

                          <!-- 영상 목록 -->
                          <ng-container *ngIf="!IsLoading && countVideo > 0">
                            <div class="subject-box total-subject-video" style="margin-top: 5.0rem">
                              <div class="subject-txt">영상 검색 결과</div>
                            </div>
                            <ul>
                              <li *ngFor="let video of listVideo; let idx = index">
                                <app-video-total-item [video]="video"
                                                      (viewInit)="onVideoViewInit($event)">
                                </app-video-total-item>
                              </li>

                              <li *ngIf="!IsLoading && listVideo && countVideo > listVideo.length">
                                <a class="more-result"
                                   [routerLink]="['/movie-collect', LIST_TYPE.SERVER]" [queryParams]="{ keyword: keyword }">{{ countVideo }}개 더 보러 가기</a>
                              </li>
                            </ul>
                          </ng-container>

                          <ul *ngIf="IsLoading">
                            <li class="reload-icon">
                              <img src="assets/img/loading_icon.gif">
                            </li>
                          </ul>


                          <ul *ngIf="!IsLoading && !(loadComplete$ | async)">
                            <li class="no-result" >
                              <div class="no-result-img"></div>
                              <div class="no-result-txt">결과가 없습니다.</div>
                            </li>
                          </ul>

                        </div>
                      </article>

                    </div>

                  </div>
                  <div class="page-box">

                    <!-- 도움말 -->
                    <app-word-help-btn></app-word-help-btn>

                    <app-word-detail #wordDetail
                                     *ngIf="curWord"
                                     [autoPlay]="autoPlay"
                                     [word_id]="curWord.id"></app-word-detail>

                    <app-example-detail *ngIf="curExample"
                                        [example]="curExample"
                                        [exampleSJ]="curExampleSJ"
                                        [sendingBookmark]="sendingExampleBookmark"
                                        (toggleBookmark)="onToggleExampleBookmark($event)">
                    </app-example-detail>

                    <app-dialect-detail *ngIf="curDialect"
                                        class="page-contents over-y scroll-effect"
                                        [dialect_id]="curDialect.id"></app-dialect-detail>

                    <app-proverb-detail *ngIf="curProverb"
                                        class="page-contents over-y scroll-effect"
                                        [proverb]="curProverb"
                                        [selected]="true"
                                        [expanded]="true">
                    </app-proverb-detail>

                    <app-saseung3-item *ngIf="curSaseung"
                                       class="page-contents over-y scroll-effect"
                                       [saseung3]="curSaseung"
                                       [showHangul]="true"
                                       [detailMode]="true"
                                       [showBookmarkButton]="true">
                    </app-saseung3-item>
                  </div>

                  <div *ngIf="showScrollDown"
                       class="scroll-down"
                       (mousedown)="onStartScrollDown($event)"
                       (mouseup)="onEndScrollDown($event)"
                       (mouseleave)="onEndScrollDown($event)"
                       (touchstart)="onStartScrollDown($event)"
                       (touchend)="onEndScrollDown($event)"
                       (touchcancel)="onEndScrollDown($event)">
                  </div>
                </div>


              </div>

            </div>



          </article>

        </div>

      </div>

    </section>


  </div>


  <!-- app-footer></app-footer -->

  <app-common-popups></app-common-popups>

</div>
